import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ErrorAlert({ error }) {
  const { t } = useTranslation();

  return <Alert severity="error">{error?.message ?? t("ERROR.TEXT")}</Alert>;
}
